import React from 'react';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '../lib/analytics';
import './WhatsAppButton.css';

// Digits only, no +, no spaces — that is the format wa.me expects.
const NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || '19293228385').replace(/\D/g, '');

/**
 * Click-to-chat, floating above the AI assistant.
 *
 * WhatsApp is the default business channel across the Gulf and the Levant,
 * where most of our clients are, and a chat costs a prospect far less effort
 * than a contact form. The trade-off is that tapping this takes them off the
 * site entirely, so the click is recorded first — otherwise every conversation
 * WhatsApp produces would be invisible to campaign attribution and paid traffic
 * would look like it converted nothing.
 */
export default function WhatsAppButton() {
  const { t } = useTranslation();

  const href = `https://wa.me/${NUMBER}?text=${encodeURIComponent(t('whatsapp.prefill'))}`;

  const handleClick = () => {
    // Fired as a beacon so it survives the navigation to WhatsApp.
    trackEvent('whatsapp_click');
  };

  return (
    <a
      className="wa-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label={t('whatsapp.aria')}
      title={t('whatsapp.aria')}
    >
      <svg className="wa-fab-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35z"
        />
        <path
          fill="currentColor"
          d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.85 9.85 0 0 0 12.04 2zm0 18.15h-.01a8.23 8.23 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24a8.2 8.2 0 0 1 5.83 2.42 8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23z"
        />
      </svg>
      <span className="wa-fab-label">{t('whatsapp.label')}</span>
    </a>
  );
}
